import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35, getLuzesStatusFlex8, statusDasLuzesFlex8} from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {

  const [expanded, setExpanded] = useState({
    SanMarino: false,
    Positano: false,
    Outros: false,
  });

  const groupRefs = useRef({
    grupo01: React.createRef(),
    grupo02: React.createRef(),
    grupo03: React.createRef(),
    grupo04: React.createRef(),
    grupo08: React.createRef(),
    grupo09: React.createRef(),
    grupo10: React.createRef(),
    grupo12: React.createRef(),
    grupo13: React.createRef(),
    grupo14: React.createRef(),
    grupo15: React.createRef(),
    grupo16: React.createRef(),
    grupo17: React.createRef(),
    grupo18: React.createRef(),
    grupo19: React.createRef(),
    grupo20: React.createRef(),
    grupo21: React.createRef(),
    grupo22: React.createRef(),
    grupo23: React.createRef(),
    grupo24: React.createRef(),
    gruptonull: React.createRef(),
    grupo26: React.createRef(),
    grupo27: React.createRef(),
    grupo25: React.createRef(),
    grupo29: React.createRef(),
    grupo30: React.createRef(),
    grupo31: React.createRef(),
    grupo32: React.createRef(),
    grupo42: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo01: false,
    grupo02: false,
    grupo03: false,
    grupo04: false,
    grupo08: false,
    grupo09: false,
    grupo10: false,
    grupo12: false,
    grupo13: false,
    grupo14: false,
    grupo15: false,
    grupo16: false,
    grupo17: false,
    grupo18: false,
    grupo19: false,
    grupo20: false,
    grupo21: false,
    grupo22: false,
    grupo23: false,
    grupo24: false,
    gruptonull: false,
    grupo26: false,
    grupo27: false,
    grupo25: false,
    grupo29: false,
    grupo30: false,
    grupo31: false,
    grupo32: false,
    grupo42: false,
  });

  const [loading, setLoading] = useState(true);


  const toggleExpand = (section) => {
    setExpanded((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setExpanded({
        SanMarino: false,
        Positano: false,
        Outros: false,
      });
    }, 30000); // 30000 ms = 30 seconds

    return () => clearInterval(intervalId);
  }, [expanded]);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      const data = await getLuzesStatusFlex8();
      updateLightGroup(data);
      setLoading(false);
      console.log("Status das luzes Flex35:", statusDasLuzesFlex35);
      console.log("Status das luzes Flex8:", statusDasLuzesFlex8);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 8200);
  
    return () => clearInterval(intervalId);
  }, []);

  const updateLightGroup = (data) => {
    setImageStates({
      grupo01: statusDasLuzesFlex35.includes("1A10") && !statusDasLuzesFlex35.includes("1A00"),
      grupo02: statusDasLuzesFlex35.includes("1B10") && !statusDasLuzesFlex35.includes("1B00"),
      grupo03: statusDasLuzesFlex35.includes("1C10") && !statusDasLuzesFlex35.includes("1C00"),
      grupo04: statusDasLuzesFlex35.includes("1D10") && !statusDasLuzesFlex35.includes("1D00"),
      grupo08: statusDasLuzesFlex35.includes("1H10") && !statusDasLuzesFlex35.includes("1H00"),
      grupo09: statusDasLuzesFlex35.includes("1I10") && !statusDasLuzesFlex35.includes("1I00"),
      grupo10: statusDasLuzesFlex35.includes("1J10") && !statusDasLuzesFlex35.includes("1J00"),
      grupo12: statusDasLuzesFlex35.includes("1L10") && !statusDasLuzesFlex35.includes("1L00"),
      grupo13: statusDasLuzesFlex35.includes("1M10") && !statusDasLuzesFlex35.includes("1M00"),
      grupo14: statusDasLuzesFlex35.includes("1N10") && !statusDasLuzesFlex35.includes("1N00"),
      grupo15: statusDasLuzesFlex35.includes("1O10") && !statusDasLuzesFlex35.includes("1O00"),
      grupo16: statusDasLuzesFlex35.includes("1P10") && !statusDasLuzesFlex35.includes("1P00"),
      grupo17: statusDasLuzesFlex35.includes("1Q10") && !statusDasLuzesFlex35.includes("1Q00"),
      grupo18: statusDasLuzesFlex35.includes("1R10") && !statusDasLuzesFlex35.includes("1R00"),
      grupo19: statusDasLuzesFlex35.includes("1S10") && !statusDasLuzesFlex35.includes("1S00"),
      grupo20: statusDasLuzesFlex35.includes("1T10") && !statusDasLuzesFlex35.includes("1T00"),
      grupo21: statusDasLuzesFlex35.includes("1U10") && !statusDasLuzesFlex35.includes("1U00"),
      grupo22: statusDasLuzesFlex35.includes("1V10") && !statusDasLuzesFlex35.includes("1V00"),
      grupo23: statusDasLuzesFlex35.includes("1W10") && !statusDasLuzesFlex35.includes("1W00"),
      grupo24: statusDasLuzesFlex35.includes("1X10") && !statusDasLuzesFlex35.includes("1X00"),
      //gruptonull: statusDasLuzesFlex35.includes("1Y10") && !statusDasLuzesFlex35.includes("1Y00"),
      grupo26: statusDasLuzesFlex35.includes("1Z10") && !statusDasLuzesFlex35.includes("1Z00"),
      grupo27: statusDasLuzesFlex35.includes("1a10") && !statusDasLuzesFlex35.includes("1a00"),
      grupo25: statusDasLuzesFlex35.includes("1Y10") && !statusDasLuzesFlex35.includes("1Y00"),
      grupo29: statusDasLuzesFlex35.includes("1c10") && !statusDasLuzesFlex35.includes("1c00"),
      grupo30: statusDasLuzesFlex35.includes("1d10") && !statusDasLuzesFlex35.includes("1d00"),
      grupo31: statusDasLuzesFlex35.includes("1e10") && !statusDasLuzesFlex35.includes("1e00"),
      grupo32: statusDasLuzesFlex35.includes("1f10") && !statusDasLuzesFlex35.includes("1f00"),
      grupo42: data[0].dados[6] === "ON",
    });
  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina1">
        {/* Grupo 01 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo01}
          groupId="grupo01"
          descricao="Circulação Serviço 1 da torre San Marino"
          imageUrl={imageStates.grupo01 ? Ligado : Desligado}
          onCommand="1A10"
          offCommand="1A00"
          x={30.24}
          y={42.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo01}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 02 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo02}
          groupId="grupo02"
          descricao="Circulação Serviço 2 da torre San Marino"
          imageUrl={imageStates.grupo02 ? Ligado : Desligado}
          onCommand="1B10"
          offCommand="1B00"
          x={34.83}
          y={29.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo02}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 03 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo03}
          groupId="grupo03"
          descricao="Parede Hall Social da torre San Marino"
          imageUrl={imageStates.grupo03 ? Ligado : Desligado}
          onCommand="1C10"
          offCommand="1C00"
          x={23.43}
          y={39.2}
          width={1.55}
          height={3}
          imageState={imageStates.grupo03}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 04 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo04}
          groupId="grupo04"
          descricao="Pedente Hall Social da torre San Marino"
          imageUrl={imageStates.grupo04 ? Ligado : Desligado}
          onCommand="1D10"
          offCommand="1D00"
          x={21.27}
          y={38.3}
          width={1.55}
          height={3}
          imageState={imageStates.grupo04}
          onToggleLightGroup={handleToggleLightGroup}
        />
        
        {/* Grupo 08 */}
        
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo08}
          groupId="grupo08"
          descricao="Parede Hall Social da torre Positano"
          imageUrl={imageStates.grupo08 ? Ligado : Desligado}
          onCommand="1H10"
          offCommand="1H00"
          x={55.65}
          y={52.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo08}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 09 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo09}
          groupId="grupo09"
          descricao="Circulação Serviço da torre Positano"
          imageUrl={imageStates.grupo09 ? Ligado : Desligado}
          onCommand="1I10"
          offCommand="1I00"
          x={63.52}
          y={52.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo09}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 10 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo10}
          groupId="grupo10"
          descricao="Varanda térreo e Intermediário da torre Positano"
          imageUrl={imageStates.grupo10 ? Ligado : Desligado}
          onCommand="1J10"
          offCommand="1J00"
          x={56.85}
          y={44.6}
          width={1.55}
          height={3}
          imageState={imageStates.grupo10}
          onToggleLightGroup={handleToggleLightGroup}
        />
        
        {/* Grupo 12 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo12}
          groupId="grupo12"
          descricao="Jardim 1 entrada"
          imageUrl={imageStates.grupo12 ? Ligado : Desligado}
          onCommand="1L10"
          offCommand="1L00"
          x={15.2}
          y={35.65}
          width={1.55}
          height={3}
          imageState={imageStates.grupo12}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 13 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo13}
          groupId="grupo13"
          descricao="Jardim 2 entrada"
          imageUrl={imageStates.grupo13 ? Ligado : Desligado}
          onCommand="1M10"
          offCommand="1M00"
          x={14.75}
          y={43.26}
          width={1.55}
          height={3}
          imageState={imageStates.grupo13}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 14 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo14}
          groupId="grupo14"
          descricao="Escadaria de entrada"
          imageUrl={imageStates.grupo14 ? Ligado : Desligado}
          onCommand="1N10"
          offCommand="1N00"
          x={15.3}
          y={39.25}
          width={1.55}
          height={3}
          imageState={imageStates.grupo14}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 15 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo15}
          groupId="grupo15"
          descricao="Poste Rua 1"
          imageUrl={imageStates.grupo15 ? Ligado : Desligado}
          onCommand="1O10"
          offCommand="1O00"
          x={10.3}
          y={47.35}
          width={1.55}
          height={3}
          imageState={imageStates.grupo15}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 16 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo16}
          groupId="grupo16"
          descricao="Poste Rua 2"
          imageUrl={imageStates.grupo16 ? Ligado : Desligado}
          onCommand="1P10"
          offCommand="1P00"
          x={10.9}
          y={44.05}
          width={1.55}
          height={3}
          imageState={imageStates.grupo16}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 17 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo17}
          groupId="grupo17"
          descricao="Floreira térreo 1"
          imageUrl={imageStates.grupo17 ? Ligado : Desligado}
          onCommand="1Q10"
          offCommand="1Q00"
          x={34.3}
          y={24.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo17}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo17}
          groupId="grupo17"
          descricao="Floreira térreo 1"
          imageUrl={imageStates.grupo17 ? Ligado : Desligado}
          onCommand="1Q10"
          offCommand="1Q00"
          x={43.7}
          y={24.6}
          width={1.55}
          height={3}
          imageState={imageStates.grupo17}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 18 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo18}
          groupId="grupo18"
          descricao="Floreira térreo 2"
          imageUrl={imageStates.grupo18 ? Ligado : Desligado}
          onCommand="1R10"
          offCommand="1R00"
          x={43.5}
          y={32.95}
          width={1.55}
          height={3}
          imageState={imageStates.grupo18}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 19 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo19}
          groupId="grupo19"
          descricao="Floreira Piscina"
          imageUrl={imageStates.grupo19 ? Ligado : Desligado}
          onCommand="1S10"
          offCommand="1S00"
          x={36.5}
          y={50.25}
          width={1.55}
          height={3}
          imageState={imageStates.grupo19}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 20 reserva */}

        {/*<LightGroup
          className="light_button"
          ref={groupRefs.current.grupo20}
          groupId="grupo20"
          descricao="Circulação Serviço"
          imageUrl={imageStates.grupo20 ? Ligado : Desligado}
          onCommand="1T10"
          offCommand="1T00"
          x={40.25}
          y={43.1}
          width={1.55}
          height={3}
          imageState={imageStates.grupo20}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo20}
          groupId="grupo20"
          descricao="Circulação Serviço"
          imageUrl={imageStates.grupo20 ? Ligado : Desligado}
          onCommand="1T10"
          offCommand="1T00"
          x={45.46}
          y={43.1}
          width={1.55}
          height={3}
          imageState={imageStates.grupo20}
          onToggleLightGroup={handleToggleLightGroup}
        />/*}

        {/* Grupo 21 */}  

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo21}
          groupId="grupo21"
          descricao="Floreira interna da Piscina"
          imageUrl={imageStates.grupo21 ? Ligado : Desligado}
          onCommand="1U10"
          offCommand="1U00"
          x={38.15}
          y={64.5}
          width={1.55}
          height={3}
          imageState={imageStates.grupo21}
          onToggleLightGroup={handleToggleLightGroup}
        />

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo21}
          groupId="grupo21"
          descricao="Floreira interna da Piscina"
          imageUrl={imageStates.grupo21 ? Ligado : Desligado}
          onCommand="1U10"
          offCommand="1U00"
          x={47.8}
          y={67}
          width={1.55}
          height={3}
          imageState={imageStates.grupo21}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 22 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo22}
          groupId="grupo22"
          descricao="Piscina"
          imageUrl={imageStates.grupo22 ? Ligado : Desligado}
          onCommand="1V10"
          offCommand="1V00"
          x={43}
          y={56}
          width={1.55}
          height={3}
          imageState={imageStates.grupo22}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 23 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo23}
          groupId="grupo23"
          descricao="Perfil muro piscina"
          imageUrl={imageStates.grupo23 ? Ligado : Desligado}
          onCommand="1W10"
          offCommand="1W00"
          x={42.85}
          y={73.2}
          width={1.55}
          height={3}
          imageState={imageStates.grupo23}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 24 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo24}
          groupId="grupo24"
          descricao="Poste piscina"
          imageUrl={imageStates.grupo24 ? Ligado : Desligado}
          onCommand="1X10"
          offCommand="1X00"
          x={39.2}
          y={52.4}
          width={1.55}
          height={3}
          imageState={imageStates.grupo24}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 25 Reserva*/}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo25}
          groupId="grupo25"
          descricao="Floreira Quadra 1"
          imageUrl={imageStates.grupo25 ? Ligado : Desligado}
          onCommand="1Y10"
          offCommand="1Y00"
          x={58.9}
          y={39.1}
          width={1.55}
          height={3}
          imageState={imageStates.grupo25}
          onToggleLightGroup={handleToggleLightGroup}
        />
        

        {/* Grupo 26 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo26}
          groupId="grupo26"
          descricao="Floreira Piscina 3"
          imageUrl={imageStates.grupo26 ? Ligado : Desligado}
          onCommand="1Z10"
          offCommand="1Z00"
          x={46.8}
          y={53.1}
          width={1.55}
          height={3}
          imageState={imageStates.grupo26}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 27 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo27}
          groupId="grupo27"
          descricao="Floreira Piscina 4"
          imageUrl={imageStates.grupo27 ? Ligado : Desligado}
          onCommand="1[10"
          offCommand="1[00"
          x={52.3}
          y={66.25}
          width={1.55}
          height={3}
          imageState={imageStates.grupo27}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 25 */}

          
        {/* Grupo 29 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo29}
          groupId="grupo29"
          descricao="Floreira Quadra 2"
          imageUrl={imageStates.grupo29 ? Ligado : Desligado}
          onCommand="1]10"
          offCommand="1]00"
          x={63.2}
          y={39.2}
          width={1.55}
          height={3}
          imageState={imageStates.grupo29}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 30 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo30}
          groupId="grupo30"
          descricao="Pergolado"
          imageUrl={imageStates.grupo30 ? Ligado : Desligado}
          onCommand="1^10"
          offCommand="1^00"
          x={48.55}
          y={31.7}
          width={1.55}
          height={3}
          imageState={imageStates.grupo30}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 31 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo31}
          groupId="grupo31"
          descricao="Quadra 1"
          imageUrl={imageStates.grupo31 ? Ligado : Desligado}
          onCommand="1_10"
          offCommand="1_00"
          x={58.73}
          y={26.3}
          width={1.55}
          height={3}
          imageState={imageStates.grupo31}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 32 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo32}
          groupId="grupo32"
          descricao="Quadra 2"
          imageUrl={imageStates.grupo32 ? Ligado : Desligado}
          onCommand="1`10"
          offCommand="1`00"
          x={59.05}
          y={35.2}
          width={1.55}
          height={3}
          imageState={imageStates.grupo32}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 42 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo42}
          groupId="grupo42"
          descricao="Perfil Muro Fitness"
          imageUrl={imageStates.grupo42 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "7", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "7", status: "OFF"}}
          x={61}
          y={72}
          width={1.55}
          height={3}
          imageState={imageStates.grupo42}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Botões para clicar em cima da legenda */}

        <div className={`Topico-MenubarOthers${expanded.Outros ? '-expanded' : ''}`}>
            <p className={`topicoParagrafoMenuBar${expanded.Outros ? '-expanded' : ''}`} onClick={() => toggleExpand('Outros')}>
              <b>Outros</b>
            </p>

            {expanded.Outros && (
              <div id="outros">
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo12', !imageStates.grupo12);
                    groupRefs.current.grupo12.current.sendCommand(
                      groupRefs.current.grupo12.current.props.descricao,
                      imageStates.grupo12 ? groupRefs.current.grupo12.current.props.offCommand : groupRefs.current.grupo12.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo12 ? 'Highlighted' : ''}`}>12</p>
                  <p className="textBar">Jardim Entrada 1</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo13', !imageStates.grupo13);
                    groupRefs.current.grupo13.current.sendCommand(
                      groupRefs.current.grupo13.current.props.descricao,
                      imageStates.grupo13 ? groupRefs.current.grupo13.current.props.offCommand : groupRefs.current.grupo13.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo13 ? 'Highlighted' : ''}`}>13</p>
                  <p className="textBar">Jardim Entrada 2</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo14', !imageStates.grupo14);
                    groupRefs.current.grupo14.current.sendCommand(
                      groupRefs.current.grupo14.current.props.descricao,
                      imageStates.grupo14 ? groupRefs.current.grupo14.current.props.offCommand : groupRefs.current.grupo14.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo14 ? 'Highlighted' : ''}`}>14</p>
                  <p className="textBar">Escadaria entrada</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo15', !imageStates.grupo15);
                    groupRefs.current.grupo15.current.sendCommand(
                      groupRefs.current.grupo15.current.props.descricao,
                      imageStates.grupo15 ? groupRefs.current.grupo15.current.props.offCommand : groupRefs.current.grupo15.current.props.onCommand
                    );  
                  }
                }>
                  <p className={`NumberTextBar${imageStates.grupo15 ? 'Highlighted' : ''}`}>15</p>
                  <p className="textBar">Poste Rua 1</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo16', !imageStates.grupo16);
                    groupRefs.current.grupo16.current.sendCommand(
                      groupRefs.current.grupo16.current.props.descricao,
                      imageStates.grupo16 ? groupRefs.current.grupo16.current.props.offCommand : groupRefs.current.grupo16.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo16 ? 'Highlighted' : ''}`}>16</p>
                  <p className="textBar">Poste Rua 2</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo17', !imageStates.grupo17);
                    groupRefs.current.grupo17.current.sendCommand(
                      groupRefs.current.grupo17.current.props.descricao,
                      imageStates.grupo17 ? groupRefs.current.grupo17.current.props.offCommand : groupRefs.current.grupo17.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo17 ? 'Highlighted' : ''}`}>17</p>
                  <p className="textBar">Floreira térreo 1</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo18', !imageStates.grupo18);
                    groupRefs.current.grupo18.current.sendCommand(
                      groupRefs.current.grupo18.current.props.descricao,
                      imageStates.grupo18 ? groupRefs.current.grupo18.current.props.offCommand : groupRefs.current.grupo18.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo18 ? 'Highlighted' : ''}`}>18</p>
                  <p className="textBar">Floreira térreo 2</p>
                </div> 

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo19', !imageStates.grupo19);
                    groupRefs.current.grupo19.current.sendCommand(
                      groupRefs.current.grupo19.current.props.descricao,
                      imageStates.grupo19 ? groupRefs.current.grupo19.current.props.offCommand : groupRefs.current.grupo19.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo19 ? 'Highlighted' : ''}`}>19</p>
                  <p className="textBar">Floreira Piscina 1</p>
                </div>
                {/* Grupo 20 reserva   
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo20', !imageStates.grupo20);
                    groupRefs.current.grupo20.current.sendCommand(
                      groupRefs.current.grupo20.current.props.descricao,
                      imageStates.grupo20 ? groupRefs.current.grupo20.current.props.offCommand : groupRefs.current.grupo20.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo20 ? 'Highlighted' : ''}`}>20</p>
                  <p className="textBar">Floreira Piscina 1</p>
                </div>*/}

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo21', !imageStates.grupo21);
                    groupRefs.current.grupo21.current.sendCommand(
                      groupRefs.current.grupo21.current.props.descricao,
                      imageStates.grupo21 ? groupRefs.current.grupo21.current.props.offCommand : groupRefs.current.grupo21.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo21 ? 'Highlighted' : ''}`}>21</p>
                  <p className="textBar">Floreira int. Piscina</p>
                </div>
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo22', !imageStates.grupo22);
                    groupRefs.current.grupo22.current.sendCommand(
                      groupRefs.current.grupo22.current.props.descricao,
                      imageStates.grupo22 ? groupRefs.current.grupo22.current.props.offCommand : groupRefs.current.grupo22.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo22 ? 'Highlighted' : ''}`}>22</p>
                  <p className="textBar">Piscina</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo23', !imageStates.grupo23);
                    groupRefs.current.grupo23.current.sendCommand(
                      groupRefs.current.grupo23.current.props.descricao,
                      imageStates.grupo23 ? groupRefs.current.grupo23.current.props.offCommand : groupRefs.current.grupo23.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo23 ? 'Highlighted' : ''}`}>23</p>
                  <p className="textBar">Perfil Muro Piscina</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo24', !imageStates.grupo24);
                    groupRefs.current.grupo24.current.sendCommand(
                      groupRefs.current.grupo24.current.props.descricao,
                      imageStates.grupo24 ? groupRefs.current.grupo24.current.props.offCommand : groupRefs.current.grupo24.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo24 ? 'Highlighted' : ''}`}>24</p>
                  <p className="textBar">Poste Piscina</p>  
                </div>
                {/* Grupo 25 reserva 
                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('gruptonull', !imageStates.gruptonull);
                    groupRefs.current.gruptonull.current.sendCommand(
                      groupRefs.current.gruptonull.current.props.descricao,
                      imageStates.gruptonull ? groupRefs.current.gruptonull.current.props.offCommand : groupRefs.current.gruptonull.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.gruptonull ? 'Highlighted' : ''}`}>25</p>
                  <p className="textBar">Circulação área de lazer</p>
                </div>  */} 

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo26', !imageStates.grupo26);
                    groupRefs.current.grupo26.current.sendCommand(
                      groupRefs.current.grupo26.current.props.descricao,
                      imageStates.grupo26 ? groupRefs.current.grupo26.current.props.offCommand : groupRefs.current.grupo26.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo26 ? 'Highlighted' : ''}`}>26</p>
                  <p className="textBar">Floreira Piscina 3</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo27', !imageStates.grupo27);
                    groupRefs.current.grupo27.current.sendCommand(
                      groupRefs.current.grupo27.current.props.descricao,
                      imageStates.grupo27 ? groupRefs.current.grupo27.current.props.offCommand : groupRefs.current.grupo27.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo27 ? 'Highlighted' : ''}`}>27</p>
                  <p className="textBar">Floreira Piscina 4</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo25', !imageStates.grupo25);
                    groupRefs.current.grupo25.current.sendCommand(
                      groupRefs.current.grupo25.current.props.descricao,
                      imageStates.grupo25 ? groupRefs.current.grupo25.current.props.offCommand : groupRefs.current.grupo25.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo25 ? 'Highlighted' : ''}`}>28</p>
                  <p className="textBar">Floreira Quadra 1</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo29', !imageStates.grupo29);
                    groupRefs.current.grupo29.current.sendCommand(
                      groupRefs.current.grupo29.current.props.descricao,
                      imageStates.grupo29 ? groupRefs.current.grupo29.current.props.offCommand : groupRefs.current.grupo29.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo29 ? 'Highlighted' : ''}`}>29</p>
                  <p className="textBar">Floreira Quadra 2</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo30', !imageStates.grupo30);
                    groupRefs.current.grupo30.current.sendCommand(
                      groupRefs.current.grupo30.current.props.descricao,
                      imageStates.grupo30 ? groupRefs.current.grupo30.current.props.offCommand : groupRefs.current.grupo30.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo30 ? 'Highlighted' : ''}`}>30</p>
                  <p className="textBar">Pergolado</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo31', !imageStates.grupo31);
                    groupRefs.current.grupo31.current.sendCommand(
                      groupRefs.current.grupo31.current.props.descricao,
                      imageStates.grupo31 ? groupRefs.current.grupo31.current.props.offCommand : groupRefs.current.grupo31.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo31 ? 'Highlighted' : ''}`}>31</p>
                  <p className="textBar">Quadra 1</p>
                </div>

                <div
                  id="clickable-element-outros"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo32', !imageStates.grupo32);
                    groupRefs.current.grupo32.current.sendCommand(
                      groupRefs.current.grupo32.current.props.descricao,
                      imageStates.grupo32 ? groupRefs.current.grupo32.current.props.offCommand : groupRefs.current.grupo32.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo32 ? 'Highlighted' : ''}`}>32</p>
                  <p className="textBar">Quadra 2</p>
                </div>
                
                <div
                  id="clickable-element-outros"
                  className="clickable-element-last"
                  onClick={() => {
                    handleToggleLightGroup('grupo42', !imageStates.grupo42);
                    groupRefs.current.grupo42.current.sendCommand(
                      groupRefs.current.grupo42.current.props.descricao,
                      imageStates.grupo42 ? groupRefs.current.grupo42.current.props.offCommand : groupRefs.current.grupo42.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar-last${imageStates.grupo42 ? 'Highlighted' : ''}`}>42</p>
                  <p className="textBar">Perfil muro Fitness</p>
                </div>
              </div>
            )}
          </div>
          <div className={`Topico-Menubar-Positano${expanded.Positano ? '-expanded' : ''}`}>
          <p className={`topicoParagrafoMenuBar${expanded.Positano ? '-expanded' : ''}`} onClick={() => toggleExpand('Positano')}>
              <b>Torre Positano</b>
            </p>
            {expanded.Positano && (
              <div id="positano">
                <div
                  id="clickable-element-positano"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo08', !imageStates.grupo08);
                    groupRefs.current.grupo08.current.sendCommand(
                      groupRefs.current.grupo08.current.props.descricao,
                      imageStates.grupo08 ? groupRefs.current.grupo08.current.props.offCommand : groupRefs.current.grupo08.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo08 ? 'Highlighted' : ''}`}>8</p>
                  <p className="textBar">Parede Hall Social</p>
                </div>
                <div
                  id="clickable-element-positano"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo09', !imageStates.grupo09);
                    groupRefs.current.grupo09.current.sendCommand(
                      groupRefs.current.grupo09.current.props.descricao,
                      imageStates.grupo09 ? groupRefs.current.grupo09.current.props.offCommand : groupRefs.current.grupo09.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo09 ? 'Highlighted' : ''}`}>9</p>
                  <p className="textBar">Circulação Serviço</p>
                </div>
                <div
                  id="clickable-element-positano"
                  className="clickable-element-last"
                  onClick={() => {
                    handleToggleLightGroup('grupo10', !imageStates.grupo10);
                    groupRefs.current.grupo10.current.sendCommand(
                      groupRefs.current.grupo10.current.props.descricao,
                      imageStates.grupo10 ? groupRefs.current.grupo10.current.props.offCommand : groupRefs.current.grupo10.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar-last${imageStates.grupo10 ? 'Highlighted' : ''}`}>10</p>
                  <p className="textBar">Varanda térreo</p>
                </div>
                
              </div>
              
            )}
          </div>
          <div className={`Topico-Menubar-San${expanded.SanMarino ? '-expanded' : ''}`}>
            <p className={`topicoParagrafoMenuBar${expanded.SanMarino ? '-expanded' : ''}`} onClick={() => toggleExpand('SanMarino')}>
              <b>Torre San Marino</b>
            </p>
            {expanded.SanMarino && (
              <div id="SanMarino">
                <div
                  id="clickable-element-SanMarino"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo01', !imageStates.grupo01);
                    groupRefs.current.grupo01.current.sendCommand(
                      groupRefs.current.grupo01.current.props.descricao,
                      imageStates.grupo01 ? groupRefs.current.grupo01.current.props.offCommand : groupRefs.current.grupo01.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo01 ? 'Highlighted' : ''}`}>1</p>
                  <p className="textBar">Circulação Serviço 1</p>
                </div>
                <div
                  id="clickable-element-SanMarino"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo02', !imageStates.grupo02);
                    groupRefs.current.grupo02.current.sendCommand(
                      groupRefs.current.grupo02.current.props.descricao,
                      imageStates.grupo02 ? groupRefs.current.grupo02.current.props.offCommand : groupRefs.current.grupo02.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo02 ? 'Highlighted' : ''}`}>2</p>
                  <p className="textBar">Circulação Serviço 2</p>
                </div>
                <div
                  id="clickable-element-SanMarino"
                  className="clickable-element"
                  onClick={() => {
                    handleToggleLightGroup('grupo03', !imageStates.grupo03);
                    groupRefs.current.grupo03.current.sendCommand(
                      groupRefs.current.grupo03.current.props.descricao,
                      imageStates.grupo03 ? groupRefs.current.grupo03.current.props.offCommand : groupRefs.current.grupo03.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo03 ? 'Highlighted' : ''}`}>3</p>
                  <p className="textBar">Parede Hall Social</p>
                </div>
                <div
                  id="clickable-element-SanMarino"
                  className="clickable-element-last"
                  onClick={() => {
                    handleToggleLightGroup('grupo04', !imageStates.grupo04);
                    groupRefs.current.grupo04.current.sendCommand(
                      groupRefs.current.grupo04.current.props.descricao,
                      imageStates.grupo04 ? groupRefs.current.grupo04.current.props.offCommand : groupRefs.current.grupo04.current.props.onCommand
                    );
                  }}
                >
                  <p className={`NumberTextBar-last${imageStates.grupo04 ? 'Highlighted' : ''}`}>4</p>
                  <p className="textBar">Pendente hall Social</p>
                </div>
              </div>
            )}
          </div>
        </div>
    </>
  );
};

export default React.memo(GroupLightComponent);